import { render, staticRenderFns } from "./RecorderStickerSettingsPanel.vue?vue&type=template&id=eb4e56f8&scoped=true"
import script from "./RecorderStickerSettingsPanel.vue?vue&type=script&lang=ts"
export * from "./RecorderStickerSettingsPanel.vue?vue&type=script&lang=ts"
import style0 from "./RecorderStickerSettingsPanel.vue?vue&type=style&index=0&id=eb4e56f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb4e56f8",
  null
  
)

export default component.exports